import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RecognizeTemptation() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Recognize temptation; do not be ignorant as to what sin is and how you are tempted" />
        <blockquote>
          “Do not be deceived, God is not mocked; for whatever a man sows this he will also reap.” (Galatians 6:7)
        </blockquote>

        <p>The Rebuild steps, when practiced diligently, will make us much stronger in our walk with the Lord and put us in a much better position to resist temptation when it comes. The first step in resisting temptation is to clearly recognize when we are being tempted and what the sin is we are being tempted to commit. Many Christians sin habitually, either unaware of their actions or complacent, losing consciousness of the fact that their behavior quenches the Spirit and is sinful. We must not make excuses such as “everyone does it,” “I can’t help myself,” or “God understands.” God will hold us accountable for every sin, even every careless word (Matthew 12:36, 2 Corinthians 5:10). We must diligently seek out and root out all sin, ceasing the excuses and complacency. Yes, God is love, but He also calls us to holiness and to a very high standard, even perfection (Matthew 5:48). We are called to “work out your salvation with fear and trembling” (Philippians 2:12-13).

          We must get to the point where we recognize exactly when and how we are being tempted to sin. An example of this is getting angry. It’s easy to slip into the habit of becoming irritated, angry, or frustrated over relatively insignificant things and then say hurtful things or behave in a sinful manner. Or we allow ourselves to grumble or complain, forgetting how richly blessed we are. We must strive for a thankful attitude at all times (1 Thessalonians 5:16-18). Not controlling our anger or having a thankful attitude are sins we need to become conscious of and root out.</p>
        <br />

        <ul>
          <li>
            <strong>Learn to recognize all that God considers to be sin.</strong><br />
            <em>Exodus 20:1-17, Matthew 5:21-7:27, Romans 12-13, Galatians 5:19-21, 1 Thessalonians 4:3-8</em>
          </li>
          <br />
          <li>
            <strong>Do not be ignorant of Satan’s schemes or the deceptive words and ways of his servants.</strong><br />
            <em>1 Corinthians 15:33, Ephesians 2:1-3, 5:5-10</em>
          </li>
          <br />
          <li>
            <strong>Examine everything carefully, and be willing to ask yourself tough questions about your actions.</strong><br />
            <em>1 Thessalonians 5:21-22</em>
          </li>
          <br />
          <li>
            <strong>Ask, “Am I motivated by jealousy, pleasure, or selfish ambition? Does this thing result in strife and quarrelling?”</strong><br />
            <em>James 3:13-4:4, Colossians 3:11-14</em>
          </li>
          <br />
          <li>
            <strong>Ask, “Am I motivated by a love for the world, the lust of the flesh, or the boastful pride of life?”</strong><br />
            <em>1 John 2:15-17</em>
          </li>
          <br />
          <li>
            <strong>Ask, “Is this good for my neighbor or could it make someone, especially a little one, stumble?”</strong><br />
            <em>Matthew 18:6-7, Romans 14:13-21, 1 Corinthians 8:7-13</em>
          </li>
          <br />
          <li>
            <strong>Ask, “Is this thing lawful, profitable, and edifying?”</strong><br />
            <em>1 Corinthians 6:12, James 1:25-27</em>
          </li>
          <br />
          <li>
            <strong>Ask, “Is this thing able to control me?”</strong><br />
            <em>1 Corinthians 6:12, 9:24-27</em>
          </li>
          <br />
          <li>
            <strong>Ask, “Am I making the most of my time, and do I understand what the will of the Lord is?”</strong><br />
            <em>Colossians 3:15-17</em>
          </li>
          <br />
          <li>
            <strong>Ask, “Can I do this by faith, without fear?”</strong><br />
            <em>Romans 14:23, 1 John 4:18</em>
          </li>
          <br />
          <li>
            <strong>Do I manifest the fruit of the Spirit when I do this thing?</strong><br />
            <em>Galatians 5:22-23</em>
          </li>
          <br />
          <li>
            <strong>Ask, “Am I doing this out of love for the Lord and others?”</strong><br />
            <em>Matthew 22:36-40, John 15:11-12, Romans 14:15</em>
          </li>
          <br />
          <li>
            <strong>Is your conscience bothered by this thing or trying to warn you not to do or say this thing? If so, STOP and do not do or say it.</strong><br />
            <em>Acts 24:16, Romans 2:14-16, Hebrews 13:18</em>
          </li>
          <br />
          <li>
            <strong>Can you imagine Jesus doing or saying this thing? If not, STOP and think through why not.</strong><br />
            <em>Matthew 5:48, Philippians 4:8-9</em>
          </li>
          <br />
          <li>
            <strong>Would you do or say this if Jesus were with you? If your family and friends were with you? Would you be pleased if others knew you did or said this thing?</strong><br />
            <em>Matthew 10:26, Mark 4:21-23</em>
          </li>
          <br />
          <li>
            <strong>Is this being done or said in haste or anger? Learn to think things through ahead of time and to pause before speaking or taking action.</strong><br />
            <em>Proverbs 10:19, Ephesians 4:26-27</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
